<script setup lang="ts">
import {onUnmounted,ref,watch} from 'vue'
import {useRouter} from 'vue-router'
import {NButton,NModal} from 'naive-ui'
import {getPasswordInitializationRequired} from '@/api/auth'
const props=defineProps<{userId:string|null}>()
const router=useRouter(),show=ref(false)
let epoch=0
const key=(id:string)=>`saaserp.password-setup.dismissed:${id}`
watch(()=>props.userId,async id=>{
  const request=++epoch;show.value=false
  if(!id)return
  try{if(localStorage.getItem(key(id))==='1')return}catch{/* Storage restrictions must never block login. */}
  try{const needed=await getPasswordInitializationRequired();if(request===epoch&&props.userId===id)show.value=needed===true}catch{/* This optional reminder must not block normal use. */}
},{immediate:true})
onUnmounted(()=>{epoch++})
function dismiss(){show.value=false;if(props.userId)try{localStorage.setItem(key(props.userId),'1')}catch{/* optional preference */}}
function setup(){dismiss();void router.push('/settings')}
</script>
<template>
  <NModal :show="show" preset="card" title="设置备用登录密码" style="width:400px;max-width:calc(100vw - 32px)" @update:show="value=>{if(!value)dismiss()}">
    <p>以后也可以使用密码登录。你仍可继续使用短信或微信登录。</p>
    <div class="setup-actions"><NButton @click="dismiss">稍后设置</NButton><NButton type="primary" @click="setup">去设置密码</NButton></div>
  </NModal>
</template>
<style scoped>.setup-actions{display:flex;justify-content:flex-end;gap:10px;margin-top:20px}p{margin:0;font-size:14px;line-height:1.7}</style>
